import React from 'react'

import { palette, Text } from 'main/ui'
import { formatTime } from 'main/util/time'

interface IProps {
  start: string
  end: string
}

export default function Hours(props: IProps) {
  const { start, end } = props

  return (
    <Text css={{ color: palette.mediumGray, fontSize: '14px' }}>
      {formatTime(start)}-{formatTime(end)}
    </Text>
  )
}
